import React, { useEffect, useState, lazy } from 'react';
interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  placeholderColor?: string;
}
const LazyImage = ({
  src,
  alt,
  className = '',
  width,
  height,
  placeholderColor = '#f9f3e0'
}: LazyImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setIsLoaded(true);
    img.onerror = () => setError(true);
  }, [src]);
  if (error) {
    return <div className={`bg-gray-200 flex items-center justify-center ${className}`} style={{
      width,
      height,
      backgroundColor: placeholderColor
    }} role="img" aria-label={`Image failed to load: ${alt}`} data-id="element-377">
        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-378">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-379"></path>
        </svg>
      </div>;
  }
  return <>
      {!isLoaded && <div className={`animate-pulse ${className}`} style={{
      width,
      height,
      backgroundColor: placeholderColor
    }} aria-hidden="true" data-id="element-380" />}
      <img src={src} alt={alt} className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`} width={width} height={height} loading="lazy" style={{
      display: isLoaded ? 'block' : 'none'
    }} data-id="element-381" />
    </>;
};
export default LazyImage;